/**
 * @flow
 * @relayHash 2e4d79048fb41e2033873e0caba595bb
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type EmailClipInput = {|
  menuType?: ?string,
  contentType?: ?string,
  contentDetailType?: ?string,
  contentKey: string,
  serviceId: number,
  contentTitle?: ?string,
  contentImageUrl?: ?string,
  emailAddress: string,
  clientMutationId?: ?string,
|};
export type EmailClipMutationVariables = {|
  input: EmailClipInput
|};
export type EmailClipMutationResponse = {|
  +emailClip: ?{|
    +data: ?boolean
  |}
|};
export type EmailClipMutation = {|
  variables: EmailClipMutationVariables,
  response: EmailClipMutationResponse,
|};
*/


/*
mutation EmailClipMutation(
  $input: EmailClipInput!
) {
  emailClip(input: $input) {
    data
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "EmailClipInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "emailClip",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailClipPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "data",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "EmailClipMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "EmailClipMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "EmailClipMutation",
    "id": null,
    "text": "mutation EmailClipMutation(\n  $input: EmailClipInput!\n) {\n  emailClip(input: $input) {\n    data\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '03b247a2b376d5ae8f54795c93a5eb39';
module.exports = node;
